import { Box, Button, IconButton, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { AddCircleOutline, ArrowBack, ArrowForward, Build, FilterAlt, Handyman, North, South } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { UserType, ViewServiceRequestData } from "../../Types/UnitFeatureTypes";
import { useDispatch, useSelector } from "react-redux";
import { Actions, RootState } from "../../Redux/Reducer/rootReducer";
import { fetchServiceRequest, fetchServiceRequestCount } from "../../Redux/selectors";
import { FIXED_PAGE_ROWS } from "../../Utils/Constants";
import BuildServiceRequestsTable from "../BuildTables/BuildServiceRequestsTable";
import { useAuth } from "../../context/authContext";
import LoadingOverlay from "../CommonComponents/LoadingOverlay";
import SortComponent from "../CommonComponents/SortComponent";
import PageNavigation from "../CommonComponents/PageNavigation";
import ViewTableHeader from "../CommonComponents/ViewTableHeader";

const ViewServiceRequestsTable: React.FC = () => {
    const navigate = useNavigate();
    const [sortDirection, setSortDirection] = useState<boolean>(false);
    const [sortColumn, setSortColumn] = useState<string>('created_on');
    const allServiceRequests = useSelector(fetchServiceRequest) as ViewServiceRequestData[];
    const allServiceRequestCount = useSelector(fetchServiceRequestCount) as string;
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(0);
    const [item, setItem] = useState<ViewServiceRequestData[]>([]);
    const isLoading = useSelector((state: RootState) => state.fetchServiceRequest.request.loading);
    const dispatch = useDispatch();
    
    useEffect(() => {
        dispatch(Actions.fetch.serviceRequestActions.request({offset: currentPage * FIXED_PAGE_ROWS, sortColumn, sortDirection: sortDirection ? 'asc' : 'desc'}));
    }, [currentPage, allServiceRequestCount, sortDirection, sortColumn]);

    useEffect(() => {
        setItem(allServiceRequests);
    }, [allServiceRequests]);

    useEffect(() => {
        const totalRequest = Number(allServiceRequestCount);
        const pages = Math.ceil(totalRequest/FIXED_PAGE_ROWS);
        setTotalPages(pages);
    }, [allServiceRequestCount]);

    if (!item) {
        return (
            <Typography variant="h5" color="textSecondary">No Service Request Available</Typography>
        )
    }
    
    const handleAddServiceRequest = (event: React.MouseEvent<HTMLButtonElement>) => {
        navigate('/createServiceRequest');
    }

    return (
        <>
        <LoadingOverlay isLoading={isLoading} />
        <Paper elevation={5} sx={{mb: 2, padding: 3, borderRadius: 3}}>
            <ViewTableHeader
                title="Service Requests"
                icon={Handyman}
                handleAdd={handleAddServiceRequest}
                addText="Add Service Requests"
                sortColumn={sortColumn}
                setSortColumn={setSortColumn}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                sortValues={[
                    { value: 'title', label: 'Title'},
                    { value: 'created_on', label: 'Create Date'},
                    { value: 'unit', label: 'Unit'},
                    { value: 'priority', label: 'Priority'},
                    { value: 'status', label: 'Status'},
                ]}
            />
            <BuildServiceRequestsTable item={item} />
            <PageNavigation
                currentPage={currentPage}
                totalPages={totalPages}
                setCurrentPage={setCurrentPage}
            />
        </Paper>
        </>
    )
}

export default ViewServiceRequestsTable;